var ChartsPlugin = Marionette.Object.extend({
    initialize: function (options) {
        var self = this;

        // add props
        this.charts = options;
        if (this.charts) this.view = this.charts.chartView;
        if (this.view) this.chartView = this.view.charts;
        if (this.chartView) this.data = this.chartView.data;
        if (this.data) this.cache = this.data.cache;

        this.initPlugin(options);
    },

    initPlugin: function (options) {},

    foreachCharts: function (fct) {
        var self = this;
        if (!this.chartView || !this.chartView.charts) return;
        _.each(this.chartView.charts, function (value, key) {
            if (fct) {
                fct.apply(self, [key, value]);
            }
        });
    },
    getValueWindow: function (g) {
        if (g.axes_[0]) {
            var axis = g.axes_[0];
            if (axis.valueWindow) return axis.valueWindow;
            else return axis.valueRange || [-1, 1];
        }
    },

    getValueMaxWindow: function (g) {
        if (g.axes_[0]) {
            var axis = g.axes_[0];
            return axis.valueRange;
        }
    },

    getDateWindow: function (g) {
        if (g === undefined) {
            var currentDateWindow = [undefined, undefined];
            var setValue = function (dw, idx, f) {
                if (currentDateWindow[idx] === undefined) currentDateWindow[idx] = dw[idx];
                else currentDateWindow[idx] = f(dw[idx], currentDateWindow[idx]);
            };

            this.foreachCharts(function (id, g) {
                var dateWindow = this.getDateWindow(g);
                setValue(dateWindow, 0, Math.min);
                setValue(dateWindow, 1, Math.max);
            });

            return currentDateWindow;
        }

        var result = g.dateWindow_;
        if (!result || result.length == 0) {
            if (g.file_) {
                return this.getDateMaxWindow(g);
            }
        }

        return result;
    },

    getDateMaxWindow: function (g) {
        if (g === undefined) {
            this.foreachCharts(function (k, v) {
                g = v;
            });
        }

        var x1 = parseInt(moment(g.file_[0][0]).format('x'));
        var x2 = parseInt(moment(g.file_[g.file_.length - 1][0]).format('x'));
        return [x1, x2];
    },
});

module.exports = ChartsPlugin;
